import { pipe } from 'ramda';

import { request } from '@/api/base';
import {
  buildCmsUrl,
  CMSApiBase,
  CMSImageBase,
  getResponseCMS,
} from '@/api/cms/base';
import { getResponseCamelization } from '@/helpers/api';
import { isCMSV3 } from '@/helpers/conf';

export interface BrandAssets {
  logoDesktop: CMSImageBase | null;
  logoMobile: CMSImageBase | null;
  preloader: CMSImageBase | null;
  vipAnimatedLogo: CMSImageBase | null;
  animatedLogo: boolean;
}

export interface CMSBrandAssets extends BrandAssets, CMSApiBase {}

export const brandAssetsCMSV3 = () =>
  request<CMSBrandAssets>({
    method: 'GET',
    url: buildCmsUrl({ path: 'brand-assets' }),
  });

export const brandAssetsCMSV4 = () =>
  request<CMSBrandAssets>({
    url: buildCmsUrl({
      path: 'brand-asset',
      additionalParams: { populate: 'deep' },
    }),
    transformResponse: pipe(
      getResponseCamelization,
      getResponseCMS<CMSBrandAssets>
    ),
  });

export const brandAssetsCMS = isCMSV3 ? brandAssetsCMSV3 : brandAssetsCMSV4;
